// Navigation "you are here" matching.
//
// Menu links are plain strings ("/tsa-funding/faac/FAAC TSA Funding") while
// location.pathname can arrive percent-encoded (".../FAAC%20TSA%20Funding"), so
// compare the decoded forms and ignore a trailing slash.

export const normalizePath = (path = "") => {
  let decoded = path;
  try {
    decoded = decodeURIComponent(path);
  } catch (e) {
    // A malformed escape sequence: compare it as-is rather than throwing.
  }
  return decoded.replace(/\/+$/, "");
};

/**
 * True when `currentPath` is `link` itself or a page underneath it.
 * Also used for section headers, where `link` is the module's base route.
 */
export const isActivePath = (currentPath, link) => {
  const target = normalizePath(link);
  if (!target) return false;
  const current = normalizePath(currentPath);
  return current === target || current.startsWith(`${target}/`);
};
